import { apiSlice } from "../store/app.api";
import { supabase } from "../utils/API";
import { getTVPrograms } from "./TVProgramService";

const dayColumnName = (day: string) => {
  let str = "";
  switch (day) {
    
    case "Mon":
      str = "is_monday_active";
      break; 
    case "Tue":      
      str = "is_tuesday_active";
      break; 
    case "Wed":
      str = "is_wednesday_active";
      break;      
    case "Thu":
      str = "is_thursday_active";
      break;           
    case "Fri":
      str = "is_friday_active";
      break;            
    case "Sat":
      str = "is_saturday_active";
      break;          
    case "Sun":
      str = "is_sunday_active";
      break;  
                    
  }
  return str;
};

const authApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getTVPrograms: build.query<any, any>({
      queryFn: async (email: string) => {
        let { data } = await supabase
          .from("tv_programs")
          .select("*")
          .order("created_at", { ascending: false });
        return { data };
      },
      providesTags: ["tv_programs"],
    }),

    getTVProgram: build.query<any, any>({
      queryFn: async (id: number) => {
        let { data } = await supabase
          .from("tv_programs")
          .select("*")
          .eq("id", id);
        return { data };
      },
      providesTags: ["tv_programs"],
    }),

    getTVProgramsByChannel: build.query<
      any,
      { channelId: number; dayActive: string }
    >({      
      queryFn: async (params) => {
        console.log(dayColumnName(params.dayActive));
        let { data } = await supabase
          .from("tv_program_schedules")
          .select("*,tv_program:tv_programs(id,title,image)")
          .eq("tv_channel_id", params.channelId)
          .eq(dayColumnName(params.dayActive), true)
          .order("created_at", { ascending: true });
        // .eq(params.day_active, true);
        return { data };
      },
      providesTags: ["tv_programs"],
    }),    
    addTVProgramSchedule: build.mutation<any, any>({
      queryFn: async (tvSched: any) => {
        let { data } = await supabase
          .from("tv_program_schedules")
          .insert({'tv_program_id':15})
          .single();
        return { data };
      },
      invalidatesTags: ["channels"],
    }),

  }),
  overrideExisting: true,
});

export const {
  useGetTVProgramsQuery,
  useGetTVProgramQuery,
  useLazyGetTVProgramsByChannelQuery,
  useAddTVProgramScheduleMutation
} = authApi;
